import React from 'react'
import { useNavigate } from 'react-router-dom'
import IMAGES from '../../const/Image'

const Logo = ({ collapsed }) => {
    const navigate = useNavigate();
    return (
        <div className={collapsed ? "logo shortlogo" : "logo longlogo"}>
            {collapsed ?
                < img src={IMAGES.LogoShort} className="cursor-pointer img-fluid " alt="" onClick={() => navigate("/dashboard")} />
                :
                <img src={IMAGES.LogoHeader} className="cursor-pointer img-fluid " alt="" onClick={() => navigate("/dashboard")} />
            }
        </div>
    )
}

export default Logo